import { CREATION_ATTRIBUTE_STARTING_VALUE } from './constants';
import type { CharacterAttributes } from './types/game';

/**
 * Points already spent above the mandatory per-attribute baseline
 * (`CREATION_ATTRIBUTE_STARTING_VALUE`) — the number to subtract from
 * `CREATION_ATTRIBUTE_POINTS` to get what's left to allocate.
 *
 * `CREATION_ATTRIBUTE_POINTS` is a budget of points to raise attributes
 * *above* their floor, not a target for the raw sum: every attribute
 * already starts at `CREATION_ATTRIBUTE_STARTING_VALUE` (6 attributes x 1
 * = 6 today), so comparing the raw sum directly against the points budget
 * would show a negative "remaining" before the player has touched
 * anything.
 */
export function countAttributePointsSpent(attributes: CharacterAttributes): number {
    const values = Object.values(attributes);
    const baseline = values.length * CREATION_ATTRIBUTE_STARTING_VALUE;
    const total = values.reduce((sum, value) => sum + value, 0);
    return total - baseline;
}
